export default __webpack_public_path__ + "static/media/120.8a3bf5a1.gif";